import { render, staticRenderFns } from "./digitize.vue?vue&type=template&id=27592376&"
import script from "./digitize.vue?vue&type=script&lang=js&"
export * from "./digitize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports